import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { map } from 'rxjs/operators';
import { ApiConstants } from 'src/app/base/api-constants';
import { GlobalConstants } from 'src/app/base/global.constants';
import { HttpBaseService } from 'src/app/base/http-base.service';
import {
  deleteCustomComponent,
  getAllCustomComponent,
  getAllCustomComponentForApp,
  getAllCustomComponentWithSorting,
  getCustomComponent,
  saveCustomComponent,
  sentCustomComponents,
  sentDeleteCustomComponent,
  setAllCustomComponent,
  setAllCustomComponentForApp,
  setAllCustomComponentWthSorting,
  setCustomComponent
} from '../actions/customcomponent.actions';

@Injectable()
export class CustomComponentEffects {
  private actions$ = inject(Actions);
  private baseService = inject(HttpBaseService);
  private store = inject(Store);

  //   Get File Content
  getAllCC$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(getAllCustomComponent),
        map((action: any) => {
          if (!action.getAllCCApiConstants) {
            return;
          }
          return this.baseService[action.getAllCCApiConstants?.method](
            action.getAllCCApiConstants,
            GlobalConstants.dataTableHeaders
          ).subscribe((allCCs: any) => {
            this.store.dispatch(setAllCustomComponent({ allCCs: allCCs.results }));
          });
        })
      ),
    {
      dispatch: false
    }
  );

  getAllCCWithSorting$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(getAllCustomComponentWithSorting),
        map((action: any) => {
          if (!action.getAllCCApiConstants) {
            return;
          }
          return this.baseService[action.getAllCCApiConstants?.method](
            action.getAllCCApiConstants,
            action.filters
          ).subscribe((allCCs: any) => {
            this.store.dispatch(setAllCustomComponentWthSorting({ allCCs: allCCs.results }));
          });
        })
      ),
    {
      dispatch: false
    }
  );

  getAllCCForApp$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(getAllCustomComponentForApp),
        map((action: any) => {
          if (!action.getAllCCForApp) {
            return;
          }
          return this.baseService[action.getAllCCForApp?.method](action.getAllCCForApp).subscribe((allCCs: any) => {
            this.store.dispatch(setAllCustomComponentForApp({ allCCForApp: allCCs }));
          });
        })
      ),
    {
      dispatch: false
    }
  );

  getCCById$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(getCustomComponent),
        map((action: any) => {
          if (!action.getCCcApiConstants) {
            return;
          }
          const apiConstants = { ...action.getCCcApiConstants };
          apiConstants.url = action.getCCcApiConstants.url + action.ccId;
          return this.baseService[action.getCCcApiConstants.method](
            apiConstants,
            GlobalConstants.dataTableHeaders
          ).subscribe((currentCC: any) => {
            this.store.dispatch(setCustomComponent({ currentCC: currentCC }));
          });
        })
      ),
    {
      dispatch: false
    }
  );

  saveCCData$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(sentCustomComponents),
        map((action: any) => {
          return this.baseService[action.saveCCApiConstants?.method](
            action.saveCCApiConstants,
            action.ccData
          ).subscribe((response: any) => {
            this.store.dispatch(
              saveCustomComponent({
                ccData: response
              })
            );
          });
        })
      ),
    {
      dispatch: false
    }
  );
  deleteCustomComponent$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(sentDeleteCustomComponent),
        map((action: any) => {
          const apiConstants = { ...action.deleteCCApiConstants };
          apiConstants.url = action.deleteCCApiConstants.url + action.ccId;

          return this.baseService[action.deleteCCApiConstants?.method](apiConstants).subscribe((menuData: any) => {
            return this.store.dispatch(
              deleteCustomComponent({
                ccId: action.ccId
              })
            );
          });
        })
      ),
    {
      dispatch: false
    }
  );
}
